import React, { Component } from "react";
import { Input } from "../../forms/input";
import Signbutton from "../../forms/button";
import { connect } from "react-redux";
import InputBase from "@material-ui/core/InputBase";
import { getEnach } from "../../../store/actions/transactions";
import { EnachModal } from "../customModal";
import Image from "../../Image";
class ENACH extends Component {
  constructor(props) {
    super(props);
    const { investorData, communicationDetails, location } = this.props;
    const { state } = location;
    const Xemail =
      !!this.props.communicationDetails &&
      !!this.props.communicationDetails.length > 0 &&
      !!investorData.PAN &&
      (this.props.communicationDetails || []).find(
        (detail) =>
          detail.PAN === investorData.PAN &&
          !!detail.email &&
          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(detail.email)
      );

    const Xmobile =
      !!this.props.communicationDetails &&
      !!this.props.communicationDetails.length > 0 &&
      !!investorData.PAN &&
      (this.props.communicationDetails || []).find(
        (detail) => detail.PAN === investorData.PAN && !!detail.Mobile
      );

    const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
    const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";

    this.state = {
      email: { value: Email || "" },
      EnachOpen: false,
      eNachAMCOpen: false,
      disabled: false,
      pan: {
        value:
          !!investorData && !!investorData.PAN
            ? investorData.PAN
            : !!state && !!state.pan
            ? state.pan
            : "",
      },
      mobile: { value: Mobile },
      name: {
        value:
          !!investorData && !!investorData.invname ? investorData.invname : "",
      },
      ref: "",
      code: { value: "+91" },
    };
  }

  changeValue = (label) => async (event) => {
    const value = event.target.value;
    if (label === "mobile") {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
    if (label === "code") {
      if (!value) {
        this.setState({
          [label]: {
            value,
            isError: true,
            errorMessage: "Country Code is Mandatory",
          },
        });
      } else if (!/^[+]\d{1,3}$/.test(value)) {
        this.setState({
          [label]: {
            value,
            isError: true,
            errorMessage: "Enter a Valid Country Code",
          },
        });
      } else {
        this.setState({
          [label]: { value },
        });
      }
    }
  };
  submit = async () => {
    const {
      ref,
      EnachOpen,
      EnachRef,
      disabled,
      eNachAMCOpen,
      code,
      ...others
    } = this.state;

    const { email, mobile, pan, name } = this.state;
    const { location } = this.props;
    const { state } = location;
    if (
      !!state &&
      !!state.pan &&
      (!email.value || !mobile.value || !name.value)
    ) {
      alert("Please fill all fields to submit");
      this.setState({
        email: {
          value: this.state.email.value,
          isError: false,
          errorMessage: "",
        },
      });
    } else if (!code.value) {
      this.setState({
        code: {
          value: this.state.code.value,
          isError: true,
          errorMessage: "Country Code is Mandatory",
        },
      });
      return;
    } else if (!/^[+]\d{1,3}$/.test(code.value)) {
      this.setState({
        code: {
          value: this.state.code.value,
          isError: true,
          errorMessage: "Enter a Valid Country Code",
        },
      });
      return;
    }
    if (!this.state.mobile.value) {
      this.setState({
        mobile: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid phone number",
        },
      });
      this.mobileField.focus();
      return;
    } else if (
      !/^[6-9]\d{9}$/.test(this.state.mobile.value) &&
      this.state.code.value === "+91"
    ) {
      this.setState({
        mobile: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid phone number",
        },
      });
      this.mobileField.focus();
      return;
    } else {
      this.setState({
        disabled: true,
      });
      const params = {
        Email: this.state.email.value,
        Contact: this.state.mobile.value,
        Name: this.state.name.value,
        Pan: this.state.pan.value,
        invdistflag: "W",
        arncode: this.props.token,
        countrycode: this.state.code.value,
        customfund:"189"
      };
      const response = await this.props.getEnach(params);
      if (
        !!response &&
        !!response.DtData &&
        !!response.DtData[0] &&
        !!response.DtData[0].en_ihno
      ) {
        this.setState({
          EnachRef: response.DtData[0].en_ihno,
          EnachOpen: true,
        });
      }
    }

    // const keys = Object.keys(others);
    // const findError = keys.every((key) => !!others[key].value);
    // if (!findError) {
    //   keys.forEach((key) => {
    //     !others[key].value &&
    //       this.setState({
    //         [key]: {
    //           ...others[key],
    //           isError: true,
    //           errorMessage: `${key.toUpperCase()} is Mandatory`,
    //         },
    //       });
    //   });
    //   const firstErroredKey = keys.find((key) => !others[key].value);
    //   switch (firstErroredKey) {
    //     case "email": {
    //       this.emailField.focus();
    //       break;
    //     }
    //     case "mobile": {
    //       this.mobileField.focus();
    //       break;
    //     }
    //     case "pan": {
    //       this.panField.focus();
    //       break;
    //     }
    //     case "name": {
    //       this.nameField.focus();
    //       break;
    //     }
    //   }
    // } else if (
    //   !!this.state.pan.value &&
    //   /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(this.state.pan.value) ===
    //     false
    // ) {
    //   this.setState({
    //     pan: {
    //       ...others["pan"],
    //       isError: true,
    //       errorMessage: `Enter a vaild PAN`,
    //     },
    //   });
    //   return;
    // } else if (
    //   !!this.state.email.value &&
    //   /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
    //     this.state.email.value
    //   ) === false
    // ) {
    //   this.setState({
    //     email: {
    //       ...others["email"],
    //       isError: true,
    //       errorMessage: `Enter a vaild Email address`,
    //     },
    //   });
    //   return;
    // } else if (
    //   !!this.state.mobile.value &&
    //   /^[6-9]\d{9}$/.test(
    //     this.state.mobile.value
    //   ) === false
    // ) {
    //   this.setState({
    //     mobile: {
    //       ...others["mobile"],
    //       isError: true,
    //       errorMessage: `Enter a vaild Phone number`,
    //     },
    //   });
    //   return;
    // } else {

    // }
    this.setState({
      disabled: false,
    });
  };

  OpenEnachAMCOpen = () => {
    this.setState({
      eNachAMCOpen: true,
    });
  };

  OpenEnachAMCClose = () => {
    this.setState({
      eNachAMCOpen: false,
    });
  };

  close = () => {
    this.setState({
      EnachOpen: false,
    });
    this.props.history.push("/dashboard");
    // const refno = encodeURIComponent(btoa(this.state.EnachRef));
    // window.open(
    //   `https://api.karvymfs.com/25/Enach/EnachRegd.aspx?refno=${refno}`,
    //   "_self"
    // );
  };

  onEmailBlur = () => {
    if (
      !!this.state.email.value &&
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.state.email.value
      ) === false
    ) {
      this.setState({
        email: {
          value: "",
          isError: true,
          errorMessage: "Enter a vaild Email ID",
        },
      });
    }
  };
  render() {
    const { mobile, email, pan, name } = this.state;
    const { location } = this.props;
    const { state } = location;

    return (
      <div className="transaction-details" style={{ minHeight: "75vh" }}>
        <div className="title">eNACH</div>
        <div className="input-margin">
          <Input
            name="PAN"
            disabled={true}
            value={pan.value}
            // onKeyDown={(evt) =>
            //   (evt.key === "e" || evt.key === "." || evt.key === "-") &&
            //   evt.preventDefault()
            // }
            bordercolor="#a6a6a6"
            // onChange={this.changeValue("pan")}
            // isShowError={pan.isError}
            // inputref={(ele) => (this.panField = ele)}
            // errorMessage={this.state.pan.errorMessage}
          />
        </div>
        <div className="input-margin">
          <Input
            disabled={!!state && !!state.pan ? false : true}
            name="Investor Name"
            value={name.value}
            bordercolor="#a6a6a6"
            onChange={this.changeValue("name")}
            // isShowError={name.isError}
            // inputref={(ele) => (this.nameField = ele)}
            // errorMessage={this.state.name.errorMessage}
          />
        </div>

        <div className="input-margin">
          <Input
            name="Email ID"
            disabled={!!state && !!state.pan ? false : true}
            value={email.value}
            bordercolor="#a6a6a6"
            onChange={this.changeValue("email")}
            onBlur={this.onEmailBlur}
            isShowError={email.isError}
            // inputref={(ele) => (this.emailField = ele)}
            errorMessage={this.state.email.errorMessage}
          />
        </div>
        <div className="input-margin">
          <Input
            name="Country Code"
            value={this.state.code.value}
            onKeyDown={(evt) => {
              if (evt.key === "e" || evt.key === "." || evt.key === "-") {
                evt.preventDefault();
              }
            }}
            onChange={this.changeValue("code")}
            isError={this.state.code.isError}
            isShowError={this.state.code.isError}
            errorMessage={this.state.code.errorMessage}
            inputref={(ele) => (this.countryCodeField = ele)}
          />
        </div>
        <div className="input-margin">
          <Input
            name="Mobile"
            value={mobile.value}
            type="number"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            bordercolor="#a6a6a6"
            onChange={this.changeValue("mobile")}
            isShowError={mobile.isError}
            inputref={(ele) => (this.mobileField = ele)}
            errorMessage={this.state.mobile.errorMessage}
          />
        </div>

        {/* <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={this.OpenEnachAMCOpen}
        >
          <div
            style={{
              fontSize: 14,
              fontFamily: "OpenSans-SemiBold",
              marginRight: 5,
              color: "#0076cb",
            }}
          >
            eNACH Participating AMCs{" "}
          </div>
          <Image
            src={"/images/information.png"}
            alt="information_icon"
            style={{ height: 15 }}
          />
        </div> */}
        <div className="digital-form-button-next-div">
          <Signbutton
            buttontitle={
              !!this.state.disabled ? "Submitting.... Please wait" : "Submit"
            }
            // disabled={this.state.submitting}
            onClick={this.submit}
          />
        </div>
{/* 
        <EnachAMCModal
          open={!!this.state.eNachAMCOpen}
          close={this.OpenEnachAMCClose}
        /> */}

        <EnachModal
          message={`You have initiated the eNach successfully with Reference Number : ${this.state.EnachRef}`}
          closeYesModal={this.close}
          open={!!this.state.EnachOpen}
        />
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }, props) => {
    const { location } = props;
    const { investorData, communicationDetails, token, userId } = authReducer;
    //   const { fundsList } = transactions;
    const { fundList } = authReducer;
    return {
      investorData,
      communicationDetails,
      token,
      fundList,
      userId,
    };
  },
  { getEnach }
)(ENACH);
